import { useEffect, useRef, useState } from "react";

import SearchInput from "common/components/SearchInput";

export default function KeywordsSearch({
  keywords,
  setKeywords,
}: {
  keywords: string;
  setKeywords: (keywords: string) => void;
}) {
  const timeoutRef = useRef(null);
  const [keywordInputValue, setKeywordInputValue] = useState(keywords);

  useEffect(() => {
    if (keywordInputValue) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(
        () => setKeywords(keywordInputValue),
        800,
      );
      return () => clearTimeout(timeoutRef.current);
    }
    setKeywords(keywordInputValue);
  }, [keywordInputValue]);

  return (
    <SearchInput
      value={keywordInputValue}
      onChange={(e) => setKeywordInputValue(e.target.value)}
      onClear={() => setKeywordInputValue("")}
      placeholder="Enter keyword"
      className="max-lg:mb-4 lg:max-w-80"
    />
  );
}
